import { useMemo } from "react";
import { sessionKeys } from "../../shared/data/queryKeys";
import { queryClient } from "../../shared/data/queryClient";
import { normalizeKeys } from "../../shared/utils/normalize";
import {
  getPlanEntitlements,
  normalizeEntitlements,
} from "../../shared/utils/planEntitlements";
import { useSessionContextQuery } from "../auth/sessionContext";

export function resolveEntitlementsFromSessionContext(sessionContext) {
  const normalized = sessionContext ? normalizeKeys(sessionContext) : null;
  const organization = normalized?.organization
    ? normalizeKeys(normalized.organization)
    : null;
  const fallback = getPlanEntitlements(organization?.planTier || null, {
    seatsAllowed:
      typeof organization?.seatsAllowed === "number"
        ? organization.seatsAllowed
        : null,
  });
  return normalizeEntitlements(
    normalized?.entitlements || organization?.entitlements || null,
    organization?.planTier || null,
    {
      seatsAllowed:
        typeof organization?.seatsAllowed === "number"
          ? organization.seatsAllowed
          : null,
    },
  ) || fallback;
}

export function getCachedSessionEntitlements() {
  const cached = queryClient.getQueryData(sessionKeys.context());
  return resolveEntitlementsFromSessionContext(cached);
}

export function useEntitlements(options) {
  const query = useSessionContextQuery(options);
  const entitlements = useMemo(
    () => resolveEntitlementsFromSessionContext(query.data),
    [query.data],
  );
  const isOrgOwner = query.data?.orgRole === "owner";

  return {
    ...query,
    entitlements,
    isOrgOwner,
  };
}
